module.exports = __webpack_public_path__ + "static/media/duration.e72cdd9c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/stats/duration.svg
// module id = 195
// module chunks = 1